import React, { useEffect,useState } from "react";
import Button from '@mui/material/Button';
import axios from "axios";
import { databaseUrl } from "../../server/server.js";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../server/axios.js";
let access = localStorage.getItem("accesstoken");

const Company_main = () => {

const [Checking, setChecking] = useState('sell');
const [MenuList, setMenuList] = useState([]);
const [CompanyList, setCompanyList] = useState([]);
const [CompanyNumber, setCompanyNumber] = useState(0);

  useEffect(()=>{
    getFulldata();
    async function getFulldata(){
      const serverData = await axiosInstance.get(`/company/allsalescompany?type=${Checking}`)
      const checkMenuList = [];
      const menulistLength = serverData.data.companySalesMenu.length;
      for(let i = 0; i < menulistLength; i++){
        if(i === 12){
          const text = `${serverData.data.companySalesMenu[i].substr(2)}\n🔻`;
          checkMenuList.push(text);
          continue;
        }
        if(i > 1){
          const text = serverData.data.companySalesMenu[i].substr(2);
          checkMenuList.push(text);
          continue;
        }
        checkMenuList.push( serverData.data.companySalesMenu[i]);
      }
      const checkItemList = [];
      const itemlistLength = serverData.data.companySalseList.length;
      const itemarrayLength = serverData.data.companySalseList[0].length;
      const companySalesSUM = serverData.data.companySalseSUM.map((val,i) => {return i > 1 ? Number(val) : val}).flat();
  
      for(let i = itemlistLength-1; i >= 0 ; i--){
        const dummy_arr = [];
        for(let j = 0; j < itemarrayLength; j++){
          if(j > 1){
            const num = Number(serverData.data.companySalseList[i][j]);
              dummy_arr.push(num);
            continue;
          }
          dummy_arr.push(serverData.data.companySalseList[i][j]);
        }
        checkItemList.push(dummy_arr);
      }
      checkItemList.push(companySalesSUM);
      checkItemList.reverse();
      setCompanyNumber(itemlistLength);
      setMenuList([...checkMenuList]);
      setCompanyList([...checkItemList]);
    }
  },[Checking])

const handlechecking = (buyorSell) => {
  setChecking(buyorSell);
}
const sortingTable = (sortingnumber) => {
  const checkingSort = MenuList[sortingnumber].indexOf('\n🔻');
  const dummyMenu = [];
  for(let i = 0; i < MenuList.length; i++){
    let menu = MenuList[i];
    menu = menu.replace(/\n🔺/gi, '');
    menu = menu.replace(/\n🔻/gi, '');
    if(i === sortingnumber){
      menu = checkingSort === -1 ? menu + '\n🔻' : menu = menu + '\n🔺';
    }
    dummyMenu.push(menu);
  }
  const sortDirection = (sortingnumber,sortmark) =>{
    let direction = -1;
    if(sortmark === -1){direction = 1}
    const dummyItemArr = [...CompanyList].sort((a, b) => {
      if (a[sortingnumber] < b[sortingnumber]) return 1 * direction;
      if (a[sortingnumber] > b[sortingnumber]) return -1 * direction;
      return 0;
    });
    return dummyItemArr;

  }
  const dummyArr = sortDirection(sortingnumber,checkingSort);
  setMenuList([...dummyMenu])
  setCompanyList([...dummyArr])
}
const commaNumber = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
const commaAndZero = (number) => {
  const numb = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return numb.includes('.') ? numb : numb + '.0';
}
    return (
        <div>
          <table className="company_main">
            <thead>
            <tr key={'head'}>
              {MenuList.map((menulist,i) => 
                i === 0 ?
                <th className="toptable">
                  <div>{Checking === 'sell' ? '(매출)' : '(매입)'} {menulist} ({CompanyNumber})
                  <div className="innerMenu">
                    <Button
                      variant="contained" 
                      color="primary"
                      size="small"
                      onClick={()=>handlechecking('buy')}
                    >BUY
                    </Button>
                    <Button
                      variant="contained" 
                      color="secondary"
                      size="small"
                      onClick={()=>handlechecking('sell')}
                    >SELL
                    </Button>
                    </div>
                  </div>
                </th>
                :
                i === 1 ?
                <th className="hide"></th>
                : 
                <th><div className="underline" onClick={()=>sortingTable(i)}>{menulist}</div></th>
              )}     
            </tr>
            </thead>
            <tbody>
            {CompanyList.map((companylistarr,j,companylist) => 
              <tr key={j}>
                {companylistarr.map((companylistItem,i,companyarr) =>
                i === 0 ?
                <td className="companyname">
                  { companylistItem !== '합계'?
                    <Link to='/Company_sub' state={{ data: [companyarr[1],Checking,companyarr[0]]}} style={{ textDecoration: "none"}}>
                      <div className="rightline" title={companylistItem}>{j} {companylistItem}</div>
                    </Link> 
                    :
                    <div className="rightline"> {companylistItem}</div>
                  }
                </td>          
                :
                i === 1 ?
                <td className="hide"></td>
                :
                i === 13 ?
                <td className="companysales">{companylistItem === 0 ? '-' : commaNumber(companylistItem)}</td>
                :
                i === 15 ?
                <td className="companysales">{companylistItem === 0 ? '-' : commaAndZero(companylistItem)}</td>
                :
                i % 2 || i === 14 ?
                companylistItem === 0 ? <td></td> :
                companylistItem > 0  ?   <td className="red companysales">{commaAndZero(companylistItem)}</td>
                : <td className="blue companysales">{commaAndZero(companylistItem)}</td>

                :
                <td className="companysales">{companylistItem === 0 ? '-' : commaNumber(companylistItem)} </td>
                )
                }
              </tr>
            )}              
            </tbody>
          </table>
        </div>
    );
}
export default Company_main;